export enum IconSize {
  ExtraSmall = '1rem',
  Small = '1.125rem',
  Medium = '1.25rem',
  Large = '2.125rem',
}
